import { object, z, TypeOf } from "zod";

export enum DocumentType {
  General = 1,
  Invoice = 2,
  Accident = 3,
}

export const addDocumentSchema = object({
  job_id: z.number().nullish(),
  client_id: z.number().nullish(),
  venue_id: z.number().nullish(),
  crew_id: z.number().nullish(),
  file_name: z.string(),
  file_type: z.string(),
  file_size: z.number(),
  file_blob_location: z.string(),
  type: z.nativeEnum(DocumentType),
})

export const params = z.number();

export type AddDocumentSchema = TypeOf<typeof addDocumentSchema>;
export type Params = TypeOf<typeof params>;
